import { ActionType, createReducer } from 'typesafe-actions'

import * as Actions from './actions'
import { CitiesState } from './types'

const INITIAL_STATE: CitiesState = {
  error: false,
  list: [],
  loading: false
}

const reducer = createReducer<CitiesState, ActionType<typeof Actions>>(
  INITIAL_STATE
)
  .handleAction(Actions.getCities, state => ({
    ...state,
    error: false,
    list: [],
    loading: true
  }))
  .handleAction(Actions.getCitiesFailure, state => ({
    ...state,
    error: true,
    loading: false
  }))
  .handleAction(Actions.getCitiesSuccess, (state, { payload: { list } }) => ({
    ...state,
    list,
    loading: false
  }))

export default reducer
